export default {
    common: {
        home: '首页',
        zhen: 'EN',
        user: '用户管理',
        userList: '用户列表',
        personCenter: '个人中心',
        meeting: '会议管理',
        paper: '论文管理',
        Papers: '论文列表',
        setInfo: '编辑基本信息',
        signOut: '退出登录',
        signIn: '登录',
        signUp: '注册',
        //个人中心
        personCenterInfo:'用户信息',
        personCenterManager:'账号管理',
        personCenterLogs:'登录日志',
        //会议管理
        meetManager:'会议列表',
        paperManager:'论文列表',
        paperReviewManager:'评审论文列表',

        //论文管理 搜索框
        language:'语言',
        country:'国家/地区',
        DoubleCommit:'双重提交',
        isEnabled:'是否有效',
        evaluationResult:'审批结果',
        topic:'征文主题',
        forum:'请选择投稿的论坛',
        forum2:'投稿论坛',
        Keywords:'关键字',
        batch:'批量处理',
        ChoseBatch:'请选择批量处理',
        DownLoadXlsx:'下载论文列表 (.xlsx)',
        DownLoadxZip:'下载论文打包文件 (.zip)',
        commitPaper:'提交论文',
        all:'全部',
        ChinaWen:'中文',
        EnglishWen:'英文',
        Yes:'是',
        No:'否',
        HasEffect:'有效',
        NoEffect:'无效',
        evaluationResult1:'接受',
        evaluationResult2:'待定',
        evaluationResult3:'拒绝',
        docCode:'论文编号',
        title:'论文标题',
        authorCode:'作者',
        jigou:'机构',
        Abstract:'摘要',
        sortType:'排序方式',
        time_desc:'时间倒序',
        time:'时间正序',
        doc_desc:'论文编号倒序',
        doc:'论文编号正序',
        evaluationResult_desc:'接受<待定<拒绝',
        evaluationResultSort:'接受>待定>拒绝',
        finalScore_desc:'分数降序',
        finalScore:'分数升序',
        sort:'排序',
        search:'查询',
        reset:'重置',

        //论文管理 表格
        allPaper:'全部论文',
        Tobeallocated:'待分配',
        Tobereviewed:'待评审',
        Reviewed:'已评审',

        authorInfo:'作者',
        reviewerMan:'评审人',
        reviewerInfo:'评审意见',
        toSee:'查看',
        grade:'分数',
        reviewerResult:'评审结果',
        handle:'操作',
        pleaseReviewer:'请评审',

        manageReviewerMan:'管理评审人',
        downLoad:'下载',
        toToReviewer:'去评审',
        livePaper:'有效论文',
        notLivePaper:'无效论文',
        edit:'编辑',

        //注册登录相关
        CommonUser:'普通用户',
        ManageUser:'管理员',
        forgetPass:'忘记密码',
        rememberPass:'记住密码',
        autoPass:'自动登录',
        password:'密码',
        phone:'手机号',
        pleaseInputAccount:'请输入账号/邮箱/手机号',
        pleaseInputPass:'请输入6-18位且数字、字母或数字字母组合的密码',
        pleaseInputPhone:'请输入手机号',
        pleaseInputVerificationCode:'请输入验证码',
        getPhoneVerificationCode:'获取短信验证码',
        sendAgain:'后重新发送',
        NotNull:'不能为空',
        pleaseInputRightPhone:'请输入正确手机号',

        pleaseInputEmail:'请输入邮箱',
        email:'邮箱',
        getEmailVerificationCode:'获取验证码',
        passwordAgain:'请再次输入密码',
        register:'注册',
        enterpassword:'请输入密码',
        passIsNotSame:'两次输入密码不一致',

        //论文相关
        editPaper:'编辑论文',
        paperTitle:'论文标题',
        pleaseInputPaperTitle:'请填写论文标题',
        paperAuthorList:'作者列表',
        paperContactList:'通讯作者',
        registerAndInvitation:'邀请注册',
        noUser: '没有要添加的用户',
        createNewUser:'创建新用户',
        searchAddUser:'搜索添加用户',
        bindingEmail:'绑定邮箱',
        bindingPhone:'绑定手机号',
        name:'姓名',
        uploadFile:'附件上传',
        choseFile:'选择文件',
        Createnow:'提交',
        pleaseInputKeyWords:'请填写关键字',
        pleaseInput:'请填写',
        pleaseChose:'请选择',
        pleaseDoubleSubmit: '请选择',
        confirmEdit:'提交',
        cancel:'取消',
        delete:'删除',
        tip:'提示',
        isConfirmdelete:'是否确认删除？',
        submitTip:'提交后将覆盖上一次的内容，截稿前请完成最后修改。',
        //搜索用户
        searchUser:'搜索用户',
        account:'账号',
        registerEmail:'注册邮箱',
        registerPhone:'注册手机号',
        pleaseInputValue:'输入内容',
        add:'添加',
        //创建用户
        createUser:'创建用户',
        contactEmail:'联系邮箱',
        contactPhone:'联系手机号',
        role:'角色',
        cancelSpace:'取 消',
        createSpace:'创 建',
        index:'序号',

        //找回密码
        findBackPass:'找回密码',
        accountVerification:'账号验证',
        complete:'完成',

        //论文详情页面
        paperDetail:'论文详情',
        paperInfo:'论文信息',
        reviewing:'评审中',
        Endofreview:'评审结束',
        file:'附件',
        preview:'预览',
        reviewComments:'评审意见',
        noData:'暂无数据',
        commitReview:'提交评审',
        back:'返回',
        Scoring:'打分',
        inputReviewComments:'请输入评审意见',
        currentMeeting:'当前会议',
        fullMsg:"完善用户信息",
        sex:"性别",
        Male:"男",
        Female:"女",
        otherEmail:"联系邮箱",
        otherPhone:"联系手机号",
        isWill:"是否愿意担任本次会议的评论人",
        research:"研究领域",
        remark:"备注",
        changeUserIcon:"更换头像",
        welcomeMag:"欢迎使用会议系统",
        goMeet:"进入当前会议前端展示页",
        AccountInfo:"账号信息",
        changePass:"修改密码",
        chnagePhone:"更改手机",
        chnageEmail:"更改邮箱",
        choleRole:"选择角色",
        resetPass:"重置密码",
        fineshed:"完成",
        Next:"下一步",
        help:"帮助",
        meetingPeo:"参会人",
        clickUrl:"点击链接查看",
        wechatShare:"微信扫一扫分享",
        WeChat:"微信",
        copyShare:"复制文字进行分享",
        manageSubject:"会议管理系统",
        shareInMsg:"邀请您注册会议管理系统",
        oldPass:"旧密码",
        newPass:"新密码",
        enterNewAg:"再次输入新密码",
        trueText:"确 定",
        Organizer:"主办单位",
        Advisor:"指导单位",
        bindAccount:"绑定账号",
        msg1:"必须绑定邮箱或手机号才能使用，请选择绑定方式！",
        msg2:"若后续需要增加绑定方式，可在个人中心完成。",
        gologin:"去登录",
        labelTime:"时间",
        Region:"地区",
        other:"其他",
        shareEmail:"分享会议",
        accountTip:'建议使用邮箱或手机号作为账号',
        copySuccessfully:'复制成功',
        addMeet:"创建会议",
        upSort:"更新排序",
        pleaseSelects:"请选择批量处理方式",
        addRepeatly:"重复添加",
        selectPapers:"请选择论文",
        selectUsers:"请选择用户",
        viewMsg:"查看评审人意见",
        emailTip:'请填写常用邮箱，以便于接收评审结果。',
        organizer:'主办单位',
        location:'举办地址',
        more:'查看详情',
    },
    front: {
        startCompany:'发起单位',
        importantDate:'重要日期',
        meetIntroduce:'会议介绍',
        meetSchedule:'会议日程',
        meetOther:'论文投稿',
        submit: '投稿',
        goPc: '请前往pc浏览器进行操作！'
    },
    msg:{
        msg01:'列表信息将被用于论文信息等查询，请准确填写。添加完成后，所有作者可查看和修改本论文。',
        fileMsg:'支持pdf格式，文件大小上限为100MB。',
        keyWordsMsg:'关键字（请用英文“;”分隔）',
        createUserMsg01:'1）请正确填写TA的“联系邮箱和手机号”，创建成功后，系统将发送“邀请TA绑定账号”的信息',
        createUserMsg02:'2）后续可登陆账号修改密码',
        rightPhone:"请输入正确的手机号",
        smsSuccess:"短信验证码发送成功",
        enterName:"请输入姓名",
        enterLength:"长度在 2 到 300 个字符",
        choseSex:"请选择性别",
        enterIns:"请输入机构",
        enterPaper:"请输入论文标题",
        enterLength2:"长度在 3 到 300 个字符",
        addAuthors:"请添加作者",
        enterabstrat:"请填写摘要",
        enterkeywords:"请输入关键字",
        entertopics:"请选择征文主题",
        tryAgain:"操作失败，请稍后再试",
        successMsg:"操作成功!",
        emailCodeSuccess:"邮箱验证码发送成功",
        rightEmail:"请输入正确的邮箱",
        singSuccess:"注册成功",
        pleaseUpload:"请上传",
        addPeople:"请添加联系人",
        copySuccess:"复制成功",
        onlyfile:"只能上传一个文件，如果想修改，可以先删除之前的文件",
        noChangeTips:"提交后不可再次修改，是否确认提交？"
    }
}
